// Memorial entry for Daniel Peretz
import danielPeretzPortrait from '../../../images/daniel-peretz.jpg';

export const danielPeretzMemorial = {
  id: 43,
  name: 'Cpt. Daniel Peretz',
  images: {
    portrait: danielPeretzPortrait
  },
  info: `
"If not me, then who?" - Found in Daniel's journal

# Captain Daniel Peretz

![Daniel Peretz](${danielPeretzPortrait})
*Captain Daniel Peretz, 22, South African immigrant and tank commander*

## From Johannesburg to the Front Lines

Daniel Peretz was born in Johannesburg, South Africa. His family made aliyah in 2014, shortly after his bar mitzvah. His father, Rabbi Doron Peretz, leads the World Mizrachi Movement.

A wakeboarding injury initially barred Daniel from combat service. He fought the bureaucracy, underwent surgery, completed nine months of rehabilitation, and returned to become a tank commander. He graduated from both tank commander's course and officer's course with honors.

His journal contained the quote he lived by: "If not me, then who?"

## October 7, 2023

Daniel commanded his tank crew at Nahal Oz when Hamas attacked. He fought for hours alongside his crew - Itay Chen, Tomer Leibovitz, and Matan Angrest. His brother Yonatan was fighting just 50 meters away at Kibbutz Nahal Oz.

Daniel saved the lives of many soldiers and civilians. Eventually, terrorists surrounded his tank. He was injured and captured.

On March 17, 2024 - 163 days later - the IDF confirmed his death.

## Coming Home

His remains returned October 13, 2025 - exactly two years to the day after his capture, on Simchat Torah eve.

At his funeral at Mount Herzl, President Herzog said: "He fought until the last drop of blood, embodying the spirit of the Israeli warrior: steadfast, moral, and brave."

His sister Adina: "This isn't closure, it's proof. Proof that you are really gone. I will never hug you again."

His crewmate Matan Angrest, freed after two years in captivity, came to salute his commander: "Daniel Perez is someone to admire. He is a symbol, the epitome of this country."

His father: "You not only saved the lives of many others, you may have also saved your brother, who was fighting only 50 meters from you."

*A modern Maccabee. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/cpt-daniel-perez-22-south-african-immigrant-and-tank-commander/)
`
};
